// import CitizenHeroImage from '../../../assets/images/heroSection/CitizenPortalHeroImage.svg';
import { Image, Row } from 'antd';
import HeroButton from '../../../components/buttons/HeroButton';
import { Suspense } from 'react';
import { SpinLoader } from '../../../components/common/SpinLoader';
import classNames from 'classnames';

type HeroCitizenProps = {
  t: (key: string) => string;
};

const HeroCitizen = ({ t }: HeroCitizenProps) => {
  // const [imageLoaded, setImageLoaded] = useState<boolean>(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  return (
    <div className="hero-citizen">
      <Suspense fallback={<SpinLoader />}>
        {/* <div
          className={classNames(
            'hidden rounded-[48px] bg-gradient-to-b from-[#004cd3] to-[#81b2ec] transition-opacity duration-500 lg:block',
            { '!h-0 opacity-0': imageLoaded },
            { 'opacity-100 lg:h-[420px]': !imageLoaded }
          )}
        /> */}
        <Image
          width="100%"
          preview={false}
          src={'/images/CitizenPortalHeroImage.svg'}
          className="hero-image"
          // onLoad={() => setImageLoaded(true)}
        />
      </Suspense>
      <div className="hero-content">
        <h1 className="title"> {t('title')} </h1>
        <h2 className="subtitle"> {t('subtitle')} </h2>
        <Row className="button-container flex flex-row flex-nowrap justify-center gap-2 px-2 sm:gap-4 sm:px-4 sm:text-[2px] md:gap-6 lg:gap-8">
          <HeroButton
            children={t('action_btn1')}
            handleOnClick={() => scrollToSection('price-lookup-section')}
          />
          <HeroButton
            children={t('action_btn2')}
            handleOnClick={() => scrollToSection('price-map-section')}
          />
          <HeroButton
            children={t('action_btn3')}
            handleOnClick={() => scrollToSection('reports-section')}
          />
        </Row>
      </div>
    </div>
  );
};

export default HeroCitizen;
